import { Input } from '@liza/ui/components/ui/input';
import { cn } from '@liza/ui/utils/cn';

export interface TimeFieldProps {
  /** `HH:mm` value, or `''` when empty. */
  value: string;
  /** Called with the new `HH:mm` value. */
  onChange: (value: string) => void;
  id?: string;
  onBlur?: () => void;
  required?: boolean;
  disabled?: boolean;
  'aria-label'?: string;
  'aria-invalid'?: boolean;
  className?: string;
  'data-testid'?: string;
}

/**
 * Styled time control. Keeps native `<input type="time">` editing but hides the
 * webkit picker indicator, which renders as a near-invisible dark-on-dark icon in
 * dark mode. Value contract is the `HH:mm` string used by form state.
 *
 * The `::-webkit-calendar-picker-indicator` selector only covers Chrome/Safari;
 * Firefox renders its own time control which we don't restyle here.
 */
export function TimeField({ value, onChange, className, ...props }: TimeFieldProps): React.ReactNode {
  return (
    <Input
      type="time"
      step={60}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={cn('[&::-webkit-calendar-picker-indicator]:hidden', className)}
      {...props}
    />
  );
}
